<template>
	<div id="appraisals-index"
		 class="app-home ui-styles"
		 :class="theme">

		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :filesOpen="filesOpen" :fileOpen="fileOpen" :fileId="appraisalfile.id"
							  :fileNumber="appraisalfile.number" :reportOpen="reportOpen"
							  :reportNumber="appraisalreport.number" :versionNumber="appraisalreport.version"
							  :realEstateId="ad.id"
							  :reportId="appraisalreport.id"></side-nav-bar>

				<div class="app-container">
					<bar>
					</bar>
					<h1>{{ $t('Ad') }} <span v-if="ad.ad_date">{{ $t('from') }} {{ formatted_ad_date }}</span> <span
							v-if="ad.street_name">{{ $t('at') }} {{ ad.street_name}}</span><span
							v-if="ad.street_number">, {{ ad.street_number
						}}</span><span v-if="ad.municipality">, {{ ad.municipality.name_ine }}</span> <span
							v-if="ad.dirty">*</span>
					</h1>
					<message
							v-if="ad.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<div class="datedata">
						<p class="small">{{ $t('Created') }}: {{ millis_to_time(ad.date_created) }}</p>
						<p class="small">{{ $t('Last_modified') }}: {{ millis_to_time(ad.date_modified) }}</p>
					</div>


					<vue-tabs>
						<v-tab :title="identification_text">
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div v-if="ad.url">
											<div @click.prevent="onOpenAd"
												 style="width: fit-content; margin-left: auto">
												<icon-button icon="external-link" :text="open_ad_button_text"
															 icon_color="#004f92"
															 text_color="#004f92"
															 border_color="lightgray"></icon-button>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Address') }}</h3>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Country') }} <span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span></span></label>
													<multiselect placeholder=""
																 :value="countryValue"
																 :options="countryOptions"
																 track-by="iso_3166_alpha2_code"
																 :label="'name_en'"
																 :searchable="true"
																 v-model="ad.country"
																 @input="set_ad_country_option"></multiselect>
												</div>
											</div>

											<div class="field-container">
												<div class="ms-container" v-if="ad.country">
													<div v-if="ad.country.name_en === 'Spain'">
														<label class="field__group__label">{{ $t('Province') }}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
														<multiselect placeholder=""
																	 :value="provinceValue"
																	 :options="spanishProvinceOptions"
																	 track-by="id"
																	 :label="'name_ine'"
																	 :searchable="true"
																	 v-model="ad.province"
																	 @input="set_ad_province_option"></multiselect>
													</div>

													<div v-else>
														<label class="field__group__label">{{ $t('Province') }}</label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="ad.province"
															   @input="set_ad_province">
													</div>
												</div>
											</div>
											<div class="field-container">
												<div class="ms-container" v-if="ad.province">
													<div v-if="ad.country.name_en === 'Spain'">
														<label class="field__group__label">{{ $t('Municipality') }}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span
																class="pdf_tag">PDF</span></span></label>
														<multiselect placeholder=""
																	 :value="municipalityValue"
																	 :options="object_to_array(ad_municipalities)"
																	 track-by="id"
																	 :label="'name_ine'"
																	 :searchable="true"
																	 v-model="ad.municipality"
																	 @input="set_ad_municipality_option"></multiselect>
													</div>
													<div v-else>
														<label class="field__group__label">{{ $t('Municipality')
															}}</label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="ad.municipality"
															   @input="set_ad_municipality">
													</div>
												</div>
											</div>
											<div v-if="ad.municipality">
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Street_name')
															}}<span
																	v-if="tags_display">&emsp;<span
																	class="bde_tag">BdE</span>&emsp;<span
																	class="pdf_tag">PDF</span></span></label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="ad.street_name"
															   @input="set_ad_street_name">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Street_number')
															}}<span
																	v-if="tags_display">&emsp;<span
																	class="bde_tag">BdE</span>&emsp;<span
																	class="pdf_tag">PDF</span></span></label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   step="1"
															   spellcheck="false"
															   v-model="ad.street_number"
															   @input="set_ad_street_number">
													</div>
												</div>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Floor_name') }}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span
																class="pdf_tag">PDF</span></span></label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="ad.floor"
															   @input="set_ad_floor">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Height_situation') }}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span></span></label>
														<input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="ad.floor_number"
															   @input="set_ad_floor_number">
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Floor_type') }}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span></span></label>
														<multiselect placeholder=""
																	 :value="floor_typeValue"
																	 :options="floor_typeOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="ad.floor_type"
																	 @input="set_ad_floor_type"></multiselect>
													</div>
												</div>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Door') }}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span
																class="pdf_tag">PDF</span></span></label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="ad.door"
															   @input="set_ad_door">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Staircase') }}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span
																class="pdf_tag">PDF</span></span></label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="ad.staircase"
															   @input="set_ad_staircase">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Block') }}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span class="pdf_tag">PDF</span></span></label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="ad.block"
															   @input="set_ad_block">
													</div>
												</div>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Ad_address')
															}}</label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="ad.ad_address"
															   @input="set_ad_ad_address">
													</div>
												</div>
											</div>
										</div>
										<div class="section-container"
											 v-if="this.ad.municipality && this.ad.street_name && this.ad.street_number">
											<h3>{{ $t('Geolocation') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onGeolocate"
															@keyup.enter="onGeolocate">
										<span><icon name="globe" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Geolocate')
											}}</span>
													</button>
												</div>
												<div v-if="google_geocode_loading">
									<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																			   color="rgb(0, 79, 146)" spin></icon>&emsp;{{ $t('Loading')
										}}...</span>
												</div>

												<div class="field__group">
													<label class="field__group__label">{{ $t('Latitude') }}<span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span>&emsp;<span
															class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="number"
														   step="any"
														   spellcheck="false"
														   v-model="ad.lat"
														   @input="set_ad_lat">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Longitude') }}<span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span>&emsp;<span
															class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="number"
														   step="any"
														   spellcheck="false"
														   v-model="ad.lng"
														   @input="set_ad_lng">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Postal_code') }}<span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span>&emsp;<span
															class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="ad.postal_code"
														   @input="set_ad_postal_code">
												</div>
												<div class="field__group">
													<label class="field__group__label">X EPSG:25831<span
															v-if="tags_display">&emsp;<span
															class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="number"
														   step="any"
														   spellcheck="false"
														   v-model="ad.epsg25831_x"
														   @input="set_ad_epsg25831_x">
												</div>
												<div class="field__group">
													<label class="field__group__label">Y EPSG:25831<span
															v-if="tags_display">&emsp;<span
															class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="number"
														   step="any"
														   spellcheck="false"
														   v-model="ad.epsg25831_y"
														   @input="set_ad_epsg25831_y">
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
									<span class="help"><i>Aquesta geolocalització es correspon a l'adreça:</i>&emsp;{{ ad.google_formatted_address
										}}, ({{ ad.geohash }})</span>
												</div>
											</div>
										</div>
										<div class="section-container"
											 v-if="this.ad.epsg25831_x && this.ad.epsg25831_y">
											<h3>{{ $t('Census_section') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onRequestCensusSectionInfo"
															@keyup.enter="onRequestCensusSectionInfo">
										<span><icon name="globe" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Census_section')}}</span>
													</button>
												</div>

												<div v-if="icc_census_section_loading">
									<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																			   color="rgb(0, 79, 146)" spin></icon>&emsp;{{ $t('Loading')
										}}...</span>
												</div>

												<div class="field__group">
													<label class="field__group__label">{{ $t('Census_section_code')
														}}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="ad.census_section_code"
														   @input="set_ad_census_section_code">
												</div>

											</div>
										</div>
										<div class="section-container"
											 v-if="this.ad.epsg25831_x && this.ad.epsg25831_y">
											<h3>{{ $t('Cadastral_data') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onRequestCadastralReferenceSuggestion"
															@keyup.enter="onRequestCadastralReferenceSuggestion">
										<span><icon name="globe" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Cadastral_reference')}}</span>
													</button>
												</div>
												<div v-if="cadaster_ref_loading">
									<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																			   color="rgb(0, 79, 146)" spin></icon>&emsp;{{ $t('Loading')
										}}...</span>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Cadastral_reference')
														}}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   maxlength="20"
														   spellcheck="false"
														   v-model="ad.cadastral_reference"
														   @input="set_ad_cadastral_reference">
												</div>

												<div v-if="ad.cadastral_reference">
													<message
															v-if="ad.cadastral_reference.length > 0 && ad.cadastral_reference.length < 20"
															:text="cad_ref_error_text_01" icon_name="exclamation"
															icon_color="darkred"
															border_color="red" text_color="darkred">
													</message>
												</div>
											</div>
											<div class="field-container">
												<!--
												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onOpenCadastralList"
															@keyup.enter="onOpenCadastralList">
										<span><icon name="external-link" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Open')}}&nbsp;{{ $t('Cadastral_List')}}</span>
													</button>
												</div>
												-->
												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onOpenCadastralMap"
															@keyup.enter="onOpenCadastralMap">
										<span><icon name="external-link" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Open')}}&nbsp;{{ $t('Cadastral_Map')}}</span>
													</button>
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Construction_year')
														}}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="ad.construction_year"
														   @input="set_ad_construction_year">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Cadastral_area') }}<span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span>&emsp;<span
															class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="ad.cadastral_area"
														   @input="set_ad_cadastral_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Cadastral_data_check')
														}}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="ad.cadastral_data_check"
														   @input="set_ad_cadastral_data_check">
												</div>
											</div>
										</div>
										<div v-else>
											<message v-if="this.ad.municipality && this.ad.street_name && this.ad.street_number"
													:text="epsg_missing_text" icon_name="exclamation"
													icon_color="darkred"
													border_color="red" text_color="darkred">
											</message>
										</div>
										<div class="section-container">
											<h3>{{ $t('Registry_data') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">IDUFIR<span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="ad.registry_idufir"
														   @input="set_ad_registry_idufir">
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Info_source') }}</h3>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Ad_data_type') }}<span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span></span></label>
													<multiselect placeholder=""
																 :value="ad_data_typeValue"
																 :options="ad_data_typeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="ad.ad_data_type"
																 @input="set_ad_ad_data_type"></multiselect>

												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Ad_type') }}</label>
													<multiselect placeholder=""
																 :value="ad_typeValue"
																 :options="ad_typeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="ad.ad_type"
																 @input="set_ad_ad_type"></multiselect>
												</div>
											</div>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Property_type') }}</label>
													<multiselect placeholder=""
																 :value="property_typeValue"
																 :options="property_typeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="ad.property_type"
																 @input="set_ad_property_type"></multiselect>
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Dwelling_type') }}<span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span></span></label>
													<multiselect placeholder=""
																 :value="dwelling_typeValue"
																 :options="dwelling_typeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="ad.dwelling_type"
																 @input="set_ad_dwelling_type"></multiselect>
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Source') }}<span
															v-if="tags_display">&emsp;<span
															class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="ad.source"
														   @input="set_ad_source">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Ad_date') }}<span
															v-if="tags_display">&emsp;<span class="bde_tag">BdE</span>&emsp;<span
															class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="date"
														   spellcheck="false"
														   v-model="ad.ad_date"
														   @input="set_ad_ad_date">
												</div>
												<!--
												<div class="field__group">
													<label class="field__group__label">{{ $t('Ad_year') }}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="ad.ad_year"
														   @input="set_ad_ad_year">
												</div>
												-->
												<div class="field__group">
													<label class="field__group__label">{{ $t('Capture_date') }}<span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="date"
														   spellcheck="false"
														   v-model="ad.capture_date"
														   @input="set_ad_capture_date">
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Url') }}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="ad.url"
														   @input="set_ad_url">
												</div>
												<div class="field__group" v-if="ad.url">
													<button
															class="quote-request__aux__button"
															@click.prevent="onOpenAd"
															@keyup.enter="onOpenAd">
										<span><icon name="external-link" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Open')}}&nbsp;{{ $t('Ad')}}</span>
													</button>
												</div>
											</div>

											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Contact_telephone')
														}}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="ad.contact_telephone"
														   @input="set_ad_contact_telephone">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Contact_name') }}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="ad.contact_name"
														   @input="set_ad_contact_name">
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Ad_code') }}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="ad.ad_code"
														   @input="set_ad_ad_code">
												</div>
											</div>


										</div>
										<div class="section-container">
											<h3>{{ $t('Age') }} {{ $t('and') }} {{ $t('Conservation_status') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Construction_year')
														}}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="ad.construction_year"
														   @input="set_ad_construction_year">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Last_renovation_year')
														}}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="ad.last_renovation_year"
														   @input="set_ad_last_renovation_year">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Adopted_age') }}<span
															v-if="tags_display">&emsp;<span
															class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="ad.adopted_age"
														   @input="set_ad_adopted_age">
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Conservation_status')
														}}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span class="pdf_tag">PDF</span></span></label>
													<multiselect placeholder=""
																 :value="conservation_statusValue"
																 :options="conservation_statusOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="ad.conservation_status"
																 @input="set_ad_conservation_status"></multiselect>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Areas') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Adopted_area')
														}} (m²)<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="ad.adopted_area"
														   @input="set_ad_adopted_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Built_area')
														}} (m²)</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="ad.built_area"
														   @input="set_ad_built_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Land_area') }} (m²)<span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="ad.land_area"
														   @input="set_ad_land_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Net_area') }} (m²)</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="ad.net_area"
														   @input="set_ad_net_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Covered_outdoor_area')
														}} (m²)<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="ad.covered_outdoor_area"
														   @input="set_ad_covered_outdoor_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Uncovered_outdoor_area')
														}} (m²)<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="ad.uncovered_outdoor_area"
														   @input="set_ad_uncovered_outdoor_area">
												</div>

											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Price') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Offer_price') }} (€)<span
															v-if="tags_display">&emsp;<span class="bde_tag">BdE</span>&emsp;<span
															class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="ad.offer_price"
														   @input="set_ad_offer_price">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Unit_price')
														}} (€/m²)<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span class="pdf_tag">PDF</span></span></label>
													<!--<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="ad.offer_unit_price"
														   @input="set_ad_offer_unit_price">-->
													<span>{{ ad.offer_unit_price | formatNumber }} €/m²</span>
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Offer_price_reduction_coef') }} <span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span>&emsp;<span class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="ad.offer_price_reduction_pct"
														   @input="set_ad_offer_price_reduction_pct">
												</div>
												<div class="field__group">
													<label> Nota*</label>
													<span class="small">Reducció per concepte d'Oferta, Comercialització, Negociació, etc.. per estimar el preu de venta final</span>
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Estimated_sale_price')
														}} (€)<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span class="pdf_tag">PDF</span></span></label>
													<!--<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="ad.estimated_sale_price"
														   @input="set_ad_estimated_sale_price">-->
													<span><strong>{{ ad.estimated_sale_price | formatNumber }} €</strong></span>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Estimated_unit_sale_price')
														}} (€)<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span class="pdf_tag">PDF</span></span></label>
													<span><strong>{{ ad.estimated_unit_sale_price | formatNumber }} €/m²</strong></span>
												</div>

											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Features') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Bedrooms_number') }}<span
															v-if="tags_display">&emsp;<span class="bde_tag">BdE</span>&emsp;<span
															class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="ad.bedrooms_number"
														   @input="set_ad_bedrooms_number">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Bathrooms_number')
														}}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span>&emsp;<span class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="ad.bathrooms_number"
														   @input="set_ad_bathrooms_number">
												</div>

												<div class="field__group">
													<label class="field__group__label">{{ $t('Parking_lots_number')
														}}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="ad.parking_lots_number"
														   @input="set_ad_parking_lots_number">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Orientation') }} </label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="ad.orientation"
														   @input="set_ad_orientation">
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Air_conditioning') }}<span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="ad.air_conditioning"
														   @input="set_ad_air_conditioning">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('External_storage_room')
														}}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="ad.external_storage_room"
														   @input="set_ad_external_storage_room">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Green_areas') }}<span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="ad.green_areas"
														   @input="set_ad_green_areas">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Heating') }}<span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="ad.heating"
														   @input="set_ad_heating">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Lift') }}<span
															v-if="tags_display">&emsp;<span class="bde_tag">BdE</span>&emsp;<span
															class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="ad.lift"
														   @input="set_ad_lift">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Sports_facilities')
														}}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="ad.sports_facilities"
														   @input="set_ad_sports_facilities">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Swimming_pool') }}<span
															v-if="tags_display">&emsp;<span
															class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="ad.swimming_pool"
														   @input="set_ad_swimming_pool">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Interior_visit_check')
														}}<span
																v-if="tags_display">&emsp;<span
																class="bde_tag">BdE</span></span></label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="ad.interior_visit_check"
														   @input="set_ad_interior_visit_check">
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Qualities') }}</h3>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Quality_of_neighbourhood')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<multiselect placeholder=""
																 :value="quality_of_neighbourhoodValue"
																 :options="quality_of_neighbourhoodOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="ad.quality_of_neighbourhood"
																 @input="set_ad_quality_of_neighbourhood"></multiselect>
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Quality_of_situation')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<multiselect placeholder=""
																 :value="quality_of_situationValue"
																 :options="quality_of_situationOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="ad.quality_of_situation"
																 @input="set_ad_quality_of_situation"></multiselect>
												</div>
											</div>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Quality_of_construction')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<multiselect placeholder=""
																 :value="quality_of_constructionValue"
																 :options="quality_of_constructionOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="ad.quality_of_construction"
																 @input="set_ad_quality_of_construction"></multiselect>
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Quality_of_realestate')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<multiselect placeholder=""
																 :value="quality_of_realestateValue"
																 :options="quality_of_realestateOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="ad.quality_of_realestate"
																 @input="set_ad_quality_of_realestate"></multiselect>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Notes') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Notes_1') }}</label>
													<textarea class="field__group__textarea"
															  rows="15"
															  spellcheck="false"
															  v-model="ad.notes_1"
															  @input="set_ad_notes_1"></textarea>
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Notes_2') }}</label>
													<textarea class="field__group__textarea"
															  rows="15"
															  spellcheck="false"
															  v-model="ad.notes_2"
															  @input="set_ad_notes_2"></textarea>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="metadata_text">
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="section-container">
											<h3>{{ $t('Description') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Ad_description')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="ad.description"
														   @input="set_ad_description">
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</v-tab>
					</vue-tabs>

					<div  v-if="!this.ad.lat || !this.ad.lng">
						<message
								 :text="epsg_missing_text" icon_name="exclamation"
								 icon_color="darkred"
								 border_color="red" text_color="darkred">
						</message>
					</div>

					<div  v-if="!this.ad.geohash">
						<message
								text="Falta el Geohash (Geolocalitzar)" icon_name="exclamation"
								icon_color="darkred"
								border_color="red" text_color="darkred">
						</message>
					</div>

					<div  v-if="!this.ad.ad_type">
						<message
								text="Falta indicar el tipus d'anunci" icon_name="exclamation"
								icon_color="darkred"
								border_color="red" text_color="darkred">
						</message>
					</div>

					<div  v-if="!this.ad.ad_date">
						<message
								text="Falta la data de l'anunci" icon_name="exclamation"
								icon_color="darkred"
								border_color="red" text_color="darkred">
						</message>
					</div>

					<div  v-if="!this.ad.estimated_sale_price">
						<message
								text="Falta el preu de venta estimat" icon_name="exclamation"
								icon_color="darkred"
								border_color="red" text_color="darkred">
						</message>
					</div>

					<div  v-if="!this.ad.adopted_area">
						<message
								text="Falta la superfície adoptada" icon_name="exclamation"
								icon_color="darkred"
								border_color="red" text_color="darkred">
						</message>
					</div>



					<div v-if="!this.manually_creating_new_ad">
						<div @click.prevent="onGoToMarketStudy" style="width: fit-content; margin-left: auto">
							<icon-button icon="level-up" :text="go_to_market_study_text"
										 icon_color="black"
										 text_color="black" border_color="lightgray"></icon-button>
						</div>
					</div>
					<div v-if="!this.manually_creating_new_ad">
						<div @click.prevent="onSaveCurrentAd({go_up: false})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<div v-if="!this.manually_creating_new_ad">
						<div @click.prevent="onSaveCurrentAd({go_up: true})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_and_go_up_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<div v-if="this.manually_creating_new_ad && this.ad.lat && this.ad.lng && this.ad.geohash && this.ad.ad_type && this.ad.ad_date && this.ad.estimated_sale_price && this.ad.adopted_area">
						<div @click.prevent="onUploadCurrentAd({go_up: false})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="upload_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<message
							v-if="ad.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>


					<bar>
					</bar>

				</div>
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import { dateMixin, localStorageMixin, mathMixin, objectsMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'

    import countryOptions from '../../../options/countries'
    import spanishProvinceOptions from '../../../options/spanish_provinces'
    import ad_typeOptions from '../../../options/ad_types'
    import ad_data_typeOptions from '../../../options/ad_data_types'
    import dwelling_typeOptions from '../../../options/dwelling_types'
    import floor_typeOptions from '../../../options/floor_types'
    import property_typeOptions from '../../../options/property_types'
    import quality_of_neighbourhoodOptions from '../../../options/quality_of_neighbourhood'
    import quality_of_situationOptions from '../../../options/quality_of_situation'
    import quality_of_constructionOptions from '../../../options/quality_of_construction'
    import quality_of_realestateOptions from '../../../options/quality_of_realestate'
    import conservation_statusOptions from '../../../options/conservation_statuses'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'ad-editor',

        mixins: [
            dateMixin,
            localStorageMixin,
			mathMixin,
            objectsMixin
        ],

        data: () => ({
            master_loading: true,
            manually_creating_new_ad: false,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            cadaster_ref_loading: false,
            icc_census_section_loading: false,
            google_geocode_loading: false,
            error: null,
            success_message: null,
            metadata_text: Vue.i18n.translate('Metadata'),
            epsg_missing_text: Vue.i18n.translate('EPSG_missing_text') + '.',
            identification_text: Vue.i18n.translate('Identification'),
            marketstudies_text: Vue.i18n.translate('Market_studies'),
            appraisals_text: Vue.i18n.translate('Appraisals'),
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            new_appraisal_button_text: Vue.i18n.translate('Add_appraisal'),
            new_marketstudy_button_text: Vue.i18n.translate('Add_market_study'),
            open_ad_button_text: Vue.i18n.translate('Open') + ' ' + Vue.i18n.translate('Ad'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goback_button_text: Vue.i18n.translate('Go_back') + ' ' + Vue.i18n.translate('without_saving'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
			go_to_market_study_text: Vue.i18n.translate('Go_back_to_market_study'),
            save_button_text: Vue.i18n.translate('Save'),
            upload_button_text: Vue.i18n.translate('Upload_to_database'),
            save_and_go_up_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            cad_ref_error_text_01: Vue.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: Vue.i18n.translate('Actions'),
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            countryOptions,
            spanishProvinceOptions,
            ad_typeOptions,
            ad_data_typeOptions,
            dwelling_typeOptions,
            floor_typeOptions,
            property_typeOptions,
            quality_of_neighbourhoodOptions,
            quality_of_situationOptions,
            quality_of_constructionOptions,
            quality_of_realestateOptions,
            conservation_statusOptions,
            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            ad_typeValue: null,
            ad_data_typeValue: null,
            dwelling_typeValue: null,
            floor_typeValue: null,
            property_typeValue: null,
            quality_of_neighbourhoodValue: null,
            quality_of_situationValue: null,
            quality_of_constructionValue: null,
            quality_of_realestateValue: null,
            conservation_statusValue: null,
            appraisal_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'date_modified',
                        label: Vue.i18n.translate('Last_modified'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return moment(value).format('DD/MM/YYYY HH:mm:ss')
                        }
                    }
                ],
                selected: []
            },
            marketstudy_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'date_modified',
                        label: Vue.i18n.translate('Last_modified'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return moment(value).format('DD/MM/YYYY HH:mm:ss')
                        }
                    }
                ],
                selected: []
            }

        }),

        created () {
            if(this.$route.query.mcna){
                if(this.$route.query.mcna === 'y'){
                    this.manually_creating_new_ad = true
                }
			}

            if (this.ad.province && !this.ad_municipalities.municipalities) {

                if (this.ad.province.ine_province_code) {
                    console.log('fetching...')
                    this.FETCH_AD_MUNICIPALITIES({path: 'municipalities' + '/' + 'province_' + this.ad.province.ine_province_code + '/'}).then(() => {
                        this.master_loading = false
                    })
                } else {
                    this.master_loading = false
                }

            } else {
                this.master_loading = false
            }

        },

        components: {
            Bar,
            Message,
            IconButton,
            Spinner,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator,
            SideNavBar
        },

        computed: {
            ...mapGetters([
                'theme',
                'tags_display',
                'appraisal',
                'appraisalfile',
                'appraisalreport',
                'currentLocale',
                'marketstudy',
                'ad',
                'ad_municipalities'
            ]),
            formatted_ad_date () {
                return moment(this.ad.ad_date).format('DD/MM/YYYY')

            }
        },

        methods: {
            ...mapActions(
                [
                    'FETCH_AD_MUNICIPALITIES',
                    'GEOLOCATE_AD',
                    'REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES',
                    'REQUEST_CENSUS_SECTION_INFO',
                    'SET_AD_CADASTRAL_REFERENCE',
                    'SET_AD_CENSUS_SECTION_CODE',
                    'SET_AD_COUNTRY',
                    'SET_AD_DESCRIPTION',
                    'SET_AD_DOOR',
                    'SET_AD_EPSG25831_X',
                    'SET_AD_EPSG25831_Y',
                    'SET_AD_FLOOR',
                    'SET_AD_GOOGLE_FORMATTED_ADDRESS',
                    'SET_AD_LAT',
                    'SET_AD_LNG',
                    'SET_AD_MUNICIPALITY',
                    'SET_AD_POSTAL_CODE',
                    'SET_AD_REGISTRY_NAME',
                    'SET_AD_PROVINCE',
                    'SET_AD_STAIRCASE',
                    'SET_AD_STREET_NAME',
                    'SET_AD_STREET_NUMBER',
                    'UPDATE_AD',
                    'SET_AD_REGISTRY_IDUFIR',
                    'SET_AD_AD_ADDRESS',
                    'SET_AD_AD_CODE',
                    'SET_AD_CONTACT_TELEPHONE',
                    'SET_AD_ORIENTATION',
                    'SET_AD_SOURCE',
                    'SET_AD_URL',
                    'SET_AD_CADASTRAL_AREA',
                    'SET_AD_AD_YEAR',
                    'SET_AD_ADOPTED_AREA',
                    'SET_AD_ADOPTED_AGE',
                    'SET_AD_BATHROOMS_NUMBER',
                    'SET_AD_BEDROOMS_NUMBER',
                    'SET_AD_CONSERVATION_STATUS',
                    'SET_AD_COVERED_OUTDOOR_AREA',
                    'SET_AD_UNCOVERED_OUTDOOR_AREA',
                    'SET_AD_CONSTRUCTION_YEAR',
                    'SET_AD_ESTIMATED_SALE_PRICE',
                    'SET_AD_FLOOR_NUMBER',
                    'SET_AD_LAST_RENOVATION_YEAR',
                    'SET_AD_OFFER_PRICE',
                    'SET_AD_PARKING_LOTS_NUMBER',
                    'SET_AD_BUILT_AREA',
                    'SET_AD_LAND_AREA',
                    'SET_AD_NET_AREA',
                    'SET_AD_AD_DATE',
                    'SET_AD_CAPTURE_DATE',
                    'SET_AD_AIR_CONDITIONING',
                    'SET_AD_EXTERNAL_STORAGE_ROOM',
                    'SET_AD_GREEN_AREAS',
                    'SET_AD_HEATING',
                    'SET_AD_LIFT',
                    'SET_AD_SPORTS_FACILITIES',
                    'SET_AD_SWIMMING_POOL',
                    'SET_AD_INTERIOR_VISIT_CHECK',
                    'SET_AD_CADASTRAL_DATA_CHECK',
                    'SET_AD_NOTES_1',
                    'SET_AD_NOTES_2',
                    'SET_AD_AD_TYPE',
                    'SET_AD_AD_DATA_TYPE',
                    'SET_AD_DWELLING_TYPE',
                    'SET_AD_FLOOR_TYPE',
                    'SET_AD_PROPERTY_TYPE',
                    'SET_AD_QUALITY_OF_NEIGHBOURHOOD',
                    'SET_AD_QUALITY_OF_SITUATION',
                    'SET_AD_QUALITY_OF_CONSTRUCTION',
                    'SET_AD_QUALITY_OF_REALESTATE',
                    'SET_AD_BLOCK',
                    'SET_AD_CONTACT_NAME',
                    'SET_AD_OFFER_UNIT_PRICE',
                    'SET_AD_CONSERVATION_STATUS',
                    'SET_AD_OFFER_PRICE_REDUCTION_PCT',
                    'SET_AD_ESTIMATED_UNIT_SALE_PRICE',


                ]),
            set_ad_cadastral_reference: _.debounce(function (e) {
                this.SET_AD_CADASTRAL_REFERENCE(e.target.value)
            }, 1000),
            set_ad_census_section_code: _.debounce(function (e) {
                this.SET_AD_CENSUS_SECTION_CODE(e.target.value)
            }, 1000),
            set_ad_country_option: _.debounce(function (e) {
                console.log('set_ad_country e: ')
                console.log(e)
                this.SET_AD_COUNTRY(e)

                this.SET_AD_PROVINCE(null)
                this.ad.province = null

                this.SET_AD_MUNICIPALITY(null)
                this.ad.municipality = null

                this.SET_AD_LAT(null)
                this.ad.lat = null

                this.SET_AD_LNG(null)
                this.ad.lng = null

                this.SET_AD_EPSG25831_X(null)
                this.ad.epsg25831_x = null

                this.SET_AD_EPSG25831_Y(null)
                this.ad.epsg25831_y = null

                this.SET_AD_CADASTRAL_REFERENCE(null)
                this.ad.cadastral_reference = null

                this.SET_AD_CENSUS_SECTION_CODE(null)
                this.ad.census_section_code = null

                this.SET_AD_POSTAL_CODE(null)
                this.ad.postal_code = null

                this.SET_AD_GOOGLE_FORMATTED_ADDRESS(null)
                this.ad.google_formatted_address = null

            }, 1000),
            set_ad_description: _.debounce(function (e) {
                this.SET_AD_DESCRIPTION(e.target.value)
            }, 1000),
            set_ad_door: _.debounce(function (e) {
                this.SET_AD_DOOR(e.target.value)
            }, 1000),
            set_ad_epsg25831_x: _.debounce(function (e) {
                this.SET_AD_EPSG25831_X(e.target.value)
            }, 1000),
            set_ad_epsg25831_y: _.debounce(function (e) {
                this.SET_AD_EPSG25831_Y(e.target.value)
            }, 1000),
            set_ad_floor: _.debounce(function (e) {
                this.SET_AD_FLOOR(e.target.value)
            }, 1000),
            set_ad_lat: _.debounce(function (e) {
                this.SET_AD_LAT(e.target.value)
            }, 1000),
            set_ad_lng: _.debounce(function (e) {
                this.SET_AD_LNG(e.target.value)
            }, 1000),
            set_ad_municipality: _.debounce(function (e) {
                this.SET_AD_MUNICIPALITY(e.target.value)
            }, 1000),
            set_ad_municipality_option: _.debounce(function (e) {
                this.SET_AD_MUNICIPALITY(e)
            }, 1000),
            set_ad_postal_code: _.debounce(function (e) {
                this.SET_AD_POSTAL_CODE(e.target.value)
            }, 1000),
            set_ad_province: _.debounce(function (e) {
                this.SET_AD_PROVINCE(e.target.value).then((res) => {
                    this.SET_AD_MUNICIPALITY(null)
                    this.ad.municipality = null
                })
            }, 1000),
            set_ad_province_option: _.debounce(function (e) {
                this.SET_AD_PROVINCE(e).then((res) => {
                    this.FETCH_AD_MUNICIPALITIES({path: 'municipalities' + '/' + 'province_' + this.ad.province.ine_province_code + '/'})
                    this.SET_AD_MUNICIPALITY(null)
                    this.ad.municipality = null
                })
            }, 1000),
            set_ad_registry_name: _.debounce(function (e) {
                this.SET_AD_REGISTRY_NAME(e.target.value)
            }, 1000),
            set_ad_staircase: _.debounce(function (e) {
                this.SET_AD_STAIRCASE(e.target.value)
            }, 1000),
            set_ad_street_name: _.debounce(function (e) {
                this.SET_AD_STREET_NAME(e.target.value)
                if (!e.target.value || e.target.value.length === 0) {
                    // console.log('no street name')

                    this.SET_AD_LAT(null)
                    this.ad.lat = null

                    this.SET_AD_LNG(null)
                    this.ad.lng = null

                    this.SET_AD_EPSG25831_X(null)
                    this.ad.epsg25831_x = null

                    this.SET_AD_EPSG25831_Y(null)
                    this.ad.epsg25831_y = null

                    this.SET_AD_CADASTRAL_REFERENCE(null)
                    this.ad.cadastral_reference = null

                    this.SET_AD_CENSUS_SECTION_CODE(null)
                    this.ad.census_section_code = null

                    this.SET_AD_POSTAL_CODE(null)
                    this.ad.postal_code = null

                    this.SET_AD_GOOGLE_FORMATTED_ADDRESS(null)
                    this.ad.google_formatted_address = null

                }
            }, 1000),
            set_ad_street_number: _.debounce(function (e) {
                this.SET_AD_STREET_NUMBER(e.target.value)
            }, 1000),
            set_ad_registry_idufir: _.debounce(function (e) {
                this.SET_AD_REGISTRY_IDUFIR(e.target.value)
            }, 1000),
            set_ad_ad_address: _.debounce(function (e) {
                this.SET_AD_AD_ADDRESS(e.target.value)
            }, 1000),
            set_ad_ad_code: _.debounce(function (e) {
                this.SET_AD_AD_CODE(e.target.value)
            }, 1000),
            set_ad_contact_telephone: _.debounce(function (e) {
                this.SET_AD_CONTACT_TELEPHONE(e.target.value)
            }, 1000),
            set_ad_orientation: _.debounce(function (e) {
                this.SET_AD_ORIENTATION(e.target.value)
            }, 1000),
            set_ad_source: _.debounce(function (e) {
                this.SET_AD_SOURCE(e.target.value)
            }, 1000),
            set_ad_url: _.debounce(function (e) {
                this.SET_AD_URL(e.target.value)
            }, 1000),
            set_ad_cadastral_area: _.debounce(function (e) {
                this.SET_AD_CADASTRAL_AREA(e.target.value)
            }, 1000),
            set_ad_ad_year: _.debounce(function (e) {
                this.SET_AD_AD_YEAR(e.target.value)
            }, 1000),
            set_ad_adopted_area: _.debounce(function (e) {
                console.log('dins')
                let area = Number(e.target.value)



                let reduction_pct = this.ad.offer_price_reduction_pct
                let offer_price = this.ad.offer_price
                let estimated_sale_price = this.roundToTwo(offer_price * (1-reduction_pct))


                let offer_unit_price = this.roundToTwo(offer_price / area)
				let estimated_unit_sale_price =  this.roundToTwo(estimated_sale_price / area)


                console.log('estimated_sale_price: ')
                console.log(estimated_sale_price)


                this.SET_AD_ADOPTED_AREA(area)
				this.SET_AD_OFFER_UNIT_PRICE(offer_unit_price)

                this.SET_AD_ESTIMATED_SALE_PRICE(estimated_sale_price)
                this.SET_AD_ESTIMATED_UNIT_SALE_PRICE(estimated_unit_sale_price)

            }, 1000),
            set_ad_adopted_age: _.debounce(function (e) {
                this.SET_AD_ADOPTED_AGE(e.target.value)
            }, 1000),
            set_ad_bathrooms_number: _.debounce(function (e) {
                this.SET_AD_BATHROOMS_NUMBER(e.target.value)
            }, 1000),
            set_ad_bedrooms_number: _.debounce(function (e) {
                this.SET_AD_BEDROOMS_NUMBER(e.target.value)
            }, 1000),
            set_ad_covered_outdoor_area: _.debounce(function (e) {
                this.SET_AD_COVERED_OUTDOOR_AREA(e.target.value)
            }, 1000),
            set_ad_uncovered_outdoor_area: _.debounce(function (e) {
                this.SET_AD_UNCOVERED_OUTDOOR_AREA(e.target.value)
            }, 1000),
            set_ad_construction_year: _.debounce(function (e) {

                let construction_year = Number(e.target.value)
                this.SET_AD_CONSTRUCTION_YEAR(construction_year)

                let last_renovation_year = construction_year

                if (this.ad.last_renovation_year) {
                    last_renovation_year = this.ad.last_renovation_year

                    if (last_renovation_year < construction_year) {
                        last_renovation_year = construction_year
                    }
                }

                this.SET_AD_LAST_RENOVATION_YEAR(last_renovation_year)

                let average = Math.round(((construction_year + last_renovation_year) / 2))
                this.SET_AD_ADOPTED_AGE(average).then(() => {
                })

            }, 500),
            set_ad_offer_price_reduction_pct: _.debounce(function(e){

                let reduction_pct = this.roundToTwo(Number(e.target.value))


				let offer_price = this.ad.offer_price
				let offer_unit_price = this.ad.offer_unit_price
				let estimated_sale_price = this.roundToTwo(offer_price * (1-reduction_pct))
                let estimated_unit_sale_price = this.roundToTwo(offer_unit_price * (1-reduction_pct))


                this.SET_AD_OFFER_PRICE_REDUCTION_PCT(reduction_pct)
                this.SET_AD_ESTIMATED_SALE_PRICE(estimated_sale_price)
                this.SET_AD_ESTIMATED_UNIT_SALE_PRICE(estimated_unit_sale_price)

            }, 500),
            set_ad_estimated_sale_price: _.debounce(function (e) {
                this.SET_AD_ESTIMATED_SALE_PRICE(e.target.value)
            }, 1000),
            set_ad_floor_number: _.debounce(function (e) {
                this.SET_AD_FLOOR_NUMBER(e.target.value)
            }, 1000),
            set_ad_last_renovation_year: _.debounce(function (e) {

                let last_renovation_year = Number(e.target.value)
                this.SET_AD_LAST_RENOVATION_YEAR(last_renovation_year)

                let construction_year = 1900

                if (this.ad.construction_year) {
                    construction_year = this.ad.construction_year
                }

                this.SET_AD_CONSTRUCTION_YEAR(construction_year)

                let average = Math.round(((construction_year + last_renovation_year) / 2))
                this.SET_AD_ADOPTED_AGE(average).then(() => {
                })


            }, 500),
            set_ad_offer_price: _.debounce(function (e) {

                let offer_price = Number(e.target.value)
                let area =  this.ad.adopted_area
                let reduction_pct = this.ad.offer_price_reduction_pct

				let offer_unit_price = this.roundToTwo(offer_price/area)
				let estimated_sale_price = this.roundToTwo(offer_price * (1 - reduction_pct))
				let estimated_unit_sale_price = this.roundToTwo(offer_unit_price * (1-reduction_pct))


                this.SET_AD_OFFER_PRICE(offer_price)
                this.SET_AD_OFFER_UNIT_PRICE(offer_unit_price)
                this.SET_AD_ESTIMATED_SALE_PRICE(estimated_sale_price)
                this.SET_AD_ESTIMATED_UNIT_SALE_PRICE(estimated_unit_sale_price)

            }, 500),
            set_ad_parking_lots_number: _.debounce(function (e) {
                this.SET_AD_PARKING_LOTS_NUMBER(e.target.value)
            }, 1000),
            set_ad_built_area: _.debounce(function (e) {
                this.SET_AD_BUILT_AREA(e.target.value)
            }, 1000),
            set_ad_land_area: _.debounce(function (e) {
                this.SET_AD_LAND_AREA(e.target.value)
            }, 1000),
            set_ad_net_area: _.debounce(function (e) {
                this.SET_AD_NET_AREA(e.target.value)
            }, 1000),
            set_ad_ad_date: _.debounce(function (e) {
                this.SET_AD_AD_DATE(e.target.value)
            }, 1000),
            set_ad_capture_date: _.debounce(function (e) {
                this.SET_AD_CAPTURE_DATE(e.target.value)
            }, 1000),
            set_ad_air_conditioning: _.debounce(function (e) {
                this.SET_AD_AIR_CONDITIONING(e.target.value)
            }, 1000),
            set_ad_external_storage_room: _.debounce(function (e) {
                this.SET_AD_EXTERNAL_STORAGE_ROOM(e.target.value)
            }, 1000),
            set_ad_green_areas: _.debounce(function (e) {
                this.SET_AD_GREEN_AREAS(e.target.value)
            }, 1000),
            set_ad_heating: _.debounce(function (e) {
                this.SET_AD_HEATING(e.target.value)
            }, 1000),
            set_ad_lift: _.debounce(function (e) {
                this.SET_AD_LIFT(e.target.value)
            }, 1000),
            set_ad_sports_facilities: _.debounce(function (e) {
                this.SET_AD_SPORTS_FACILITIES(e.target.value)
            }, 1000),
            set_ad_swimming_pool: _.debounce(function (e) {
                this.SET_AD_SWIMMING_POOL(e.target.value)
            }, 1000),
            set_ad_interior_visit_check: _.debounce(function (e) {
                this.SET_AD_INTERIOR_VISIT_CHECK(e.target.value)
            }, 1000),
            set_ad_cadastral_data_check: _.debounce(function (e) {
                this.SET_AD_CADASTRAL_DATA_CHECK(e.target.value)
            }, 1000),
            set_ad_notes_1: _.debounce(function (e) {
                this.SET_AD_NOTES_1(e.target.value)
            }, 1000),
            set_ad_notes_2: _.debounce(function (e) {
                this.SET_AD_NOTES_2(e.target.value)
            }, 1000),
            set_ad_ad_type: _.debounce(function (e) {
                this.SET_AD_AD_TYPE(e)
            }, 1000),
            set_ad_ad_data_type: _.debounce(function (e) {
                this.SET_AD_AD_DATA_TYPE(e)
            }, 1000),
            set_ad_dwelling_type: _.debounce(function (e) {
                this.SET_AD_DWELLING_TYPE(e)
            }, 1000),
            set_ad_floor_type: _.debounce(function (e) {
                this.SET_AD_FLOOR_TYPE(e)
            }, 1000),
            set_ad_property_type: _.debounce(function (e) {
                this.SET_AD_PROPERTY_TYPE(e)
            }, 1000),
            set_ad_quality_of_neighbourhood: _.debounce(function (e) {
                this.SET_AD_QUALITY_OF_NEIGHBOURHOOD(e)
            }, 1000),
            set_ad_quality_of_situation: _.debounce(function (e) {
                this.SET_AD_QUALITY_OF_SITUATION(e)
            }, 1000),
            set_ad_quality_of_construction: _.debounce(function (e) {
                this.SET_AD_QUALITY_OF_CONSTRUCTION(e)
            }, 1000),
            set_ad_quality_of_realestate: _.debounce(function (e) {
                this.SET_AD_QUALITY_OF_REALESTATE(e)
            }, 1000),
            set_ad_block: _.debounce(function (e) {
                this.SET_AD_BLOCK(e.target.value)
            }, 1000),
            set_ad_contact_name: _.debounce(function (e) {
                this.SET_AD_CONTACT_NAME(e.target.value)
            }, 1000),
            set_ad_offer_unit_price: _.debounce(function (e) {
                this.SET_AD_OFFER_UNIT_PRICE(e.target.value)
            }, 1000),
            set_ad_conservation_status: _.debounce(function (e) {
                this.SET_AD_CONSERVATION_STATUS(e)
            }, 1000),
            set_ad_estimated_unit_sale_price: _.debounce(function(e){
                this.SET_AD_ESTIMATED_UNIT_SALE_PRICE(Number(e.target.value))
            }, 1000),
            onSaveCurrentAd: function (data) {
                this.UPDATE_AD({
                    key: this.ad.id,
                    object: this.ad,
                    //parent_path: this.ad.parent_path + this.ad.id,
                    path: this.ad.path + this.ad.id,
                    path_ad_locations: 'ad_locations' + '/' + this.ad.ad_type.name_db + '/' + moment(this.ad.ad_date).format('YYYY') + '/' + this.ad.geohash[0] + '/' + this.ad.geohash[1] + '/' + this.ad.geohash[2] + '/' + this.ad.geohash[3] + '/' + this.ad.geohash[4] + '/' + this.ad.geohash[5] + '/' + this.ad.geohash[6] + '/' + this.ad.geohash[7] + '/' + this.ad.geohash[8] + '/' + this.ad.geohash[9] + '/' + this.ad.geohash[10] + '/' + this.ad.geohash[11] + '/' + this.ad.id,
                    path_ads: 'ads' + '/' + this.ad.ad_type.name_db + '/' + moment(this.ad.ad_date).format('YYYY') + '/' + this.ad.geohash[0] + '/' + this.ad.geohash[1] + '/' + this.ad.geohash[2] + '/' + this.ad.geohash[3] + '/' + this.ad.geohash[4] + '/' + this.ad.geohash[5] + '/' + this.ad.geohash[6] + '/' + this.ad.geohash[7] + '/' + this.ad.geohash[8] + '/' + this.ad.geohash[9] + '/' + this.ad.geohash[10] + '/' + this.ad.geohash[11] + '/' + this.ad.id,
                    //file_id: this.appraisalfile.id,
                    //report_id: this.appraisalreport.id
                }).then((res) => {
                    if (data.go_up) {
                        this.onGoUp()
                    }
                })
            },
            onUploadCurrentAd: function (data) {

                console.log('path_ads: ')
                console.log('ads' + '/' + this.ad.ad_type.name_db + '/' + moment(this.ad.ad_date).format('YYYY') + '/' + this.ad.geohash[0] + '/' + this.ad.geohash[1] + '/' + this.ad.geohash[2] + '/' + this.ad.geohash[3] + '/' + this.ad.geohash[4] + '/' + this.ad.geohash[5] + '/' + this.ad.geohash[6] + '/' + this.ad.geohash[7] + '/' + this.ad.geohash[8] + '/' + this.ad.geohash[9] + '/' + this.ad.geohash[10] + '/' + this.ad.geohash[11] + '/' + this.ad.id)

                this.UPDATE_AD({
                    key: this.ad.id,
                    object: this.ad,
                    path: this.ad.path + this.ad.id,
                    path_ad_locations: 'ad_locations' + '/' + this.ad.ad_type.name_db + '/' + moment(this.ad.ad_date).format('YYYY') + '/' + this.ad.geohash[0] + '/' + this.ad.geohash[1] + '/' + this.ad.geohash[2] + '/' + this.ad.geohash[3] + '/' + this.ad.geohash[4] + '/' + this.ad.geohash[5] + '/' + this.ad.geohash[6] + '/' + this.ad.geohash[7] + '/' + this.ad.geohash[8] + '/' + this.ad.geohash[9] + '/' + this.ad.geohash[10] + '/' + this.ad.geohash[11] + '/' + this.ad.id,
                    path_ads: 'ads' + '/' + this.ad.ad_type.name_db + '/' + moment(this.ad.ad_date).format('YYYY') + '/' + this.ad.geohash[0] + '/' + this.ad.geohash[1] + '/' + this.ad.geohash[2] + '/' + this.ad.geohash[3] + '/' + this.ad.geohash[4] + '/' + this.ad.geohash[5] + '/' + this.ad.geohash[6] + '/' + this.ad.geohash[7] + '/' + this.ad.geohash[8] + '/' + this.ad.geohash[9] + '/' + this.ad.geohash[10] + '/' + this.ad.geohash[11] + '/' + this.ad.id,
                }).then((res) => {

                    this.$router.push({name: 'ads-index'})

                })

            },
            onGoBack: function () {
                // console.log('yeah back')
                router.go(-1)
            },
            onGoUp: function () {
                // console.log('yeah back')
                this.$router.push({name: 'marketstudy-editor', query: {appraisal_id: this.appraisal.id}})
            },
            onGoToMarketStudy: function () {
                console.log('yeah back')
				// console.log(this.appraisal.id)
                this.$router.push({name: 'marketstudy-editor', query: {appraisal_id: this.appraisal.id}})
            },
            onCancelAll: function () {
                const result = window.confirm(Vue.i18n.translate('Changes_will_be_lost_p_continue_q'))

                if (result) {
                    router.go(-1)
                } else {
                    return false

                }

            },
            onGeolocate: function () {
                this.google_geocode_loading = true
                this.GEOLOCATE_AD({
                    id: this.ad.id,
                    old_geohash: this.ad.geohash,
                    street_name: this.ad.street_name,
                    street_number: this.ad.street_number,
                    municipality: this.ad.municipality
                }).then((res) => {
                    //
                    this.google_geocode_loading = false
                })
            },
            onRequestCensusSectionInfo: function () {
                console.log('requesting census section info...')
                this.icc_census_section_loading = true
                this.REQUEST_CENSUS_SECTION_INFO({
                    x: this.ad.epsg25831_x,
                    y: this.ad.epsg25831_y
                }).then((res) => {
                    //
                    this.icc_census_section_loading = false
                })
            },
            onRequestCadastralReferenceSuggestion: function () {
                console.log('requesting cadastral reference suggestion...')
                this.cadaster_ref_loading = true
                this.REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES({
                    x: this.ad.epsg25831_x,
                    y: this.ad.epsg25831_y
                }).then((res) => {
                    //
                    this.cadaster_ref_loading = false
                })
            },
            onOpenAd: function () {
                const url = this.ad.url
                const win = window.open(url, '_blank')
                win.focus()
            },
            onOpenCadastralList: function () {
                // console.log('opening cadastral map...')
                // const url = 'https://www.whatismyreferer.com/'
                const refcat = this.ad.cadastral_reference
                const rc1 = refcat.substring(0, 7)
                const rc2 = refcat.substring(7, 14)
                const url = 'https://www1.sedecatastro.gob.es/CYCBienInmueble/OVCListaBienes.aspx?del=' + this.ad.municipality.cadaster_province_code + '&muni=' + this.ad.municipality.cadaster_municipality_code + '&rc1=' + rc1 + '&rc2=' + rc2
                const win = window.open(url, '_blank')
                win.focus()

            },
            onOpenCadastralMap: function () {
                // console.log('opening cadastral map...')

                const url = 'https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=' + this.ad.municipality.cadaster_province_code + '&mun=' + this.ad.municipality.cadaster_municipality_code + '&refcat=' + this.ad.cadastral_reference + '&final='
                const win = window.open(url, '_blank')
                win.focus()

            }

        },
        head: {
            title: {
                //inner: Vue.i18n.translate('New_contact')
                inner: 'Edit ad'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// AdEditor.vue?52ab6788